import type {
  FormControlProps as ChakraFormControlProps,
  ThemingProps,
} from '@chakra-ui/react';
import { FormControl as ChakraFormControl } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type FormControlProps = OmitChakraProps<
  ChakraFormControlProps,
  keyof ThemingProps
>;

export const FormControl = withChakraAs<FormControlProps, 'div'>((props) => {
  return <ChakraFormControl {...props} />;
});
